export const getOperatorAccountInfo = async (
  setOperatorAccountInfo,
  setAuthenticationChecked,
) => {
  const endpoint = "/admin/account.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
      credentials: "include",
    });

    if (!res.ok) {
      if (res.status === 401) {
        setAuthenticationChecked && setAuthenticationChecked("UNAUTHORIZED");
      } else if (res.status === 403) {
        setAuthenticationChecked && setAuthenticationChecked("FORBIDDEN");
      }
      return;
    }

    const data = await res.json();
    if (data.success === true) {
      setOperatorAccountInfo(data.data);
      setAuthenticationChecked && setAuthenticationChecked(null);
    } else if (data.error && data.error.code === "UNAUTHORIZED") {
      setAuthenticationChecked && setAuthenticationChecked("UNAUTHORIZED");
    } else if (data.error && data.error.code === "FORBIDDEN") {
      setAuthenticationChecked && setAuthenticationChecked("FORBIDDEN");
    } else if (data.error) {
      setAuthenticationChecked && setAuthenticationChecked(data.error);
    }
  } catch (err) {
    if (err.message.indexOf("401") > -1) {
      setAuthenticationChecked && setAuthenticationChecked("UNAUTHORIZED");
    } else if (err.message.indexOf("403") > -1) {
      setAuthenticationChecked && setAuthenticationChecked("FORBIDDEN");
    } else {
      setAuthenticationChecked && setAuthenticationChecked(err.message);
    }
  }
};

export const updateOperatorAccountInfo = async (
  OperatorAccountInfo,
  setAuthenticationChecked,
) => {
  const endpoint = "/admin/account.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(OperatorAccountInfo),
    });

    if (!res.ok) {
      if (res.status === 401) {
        alert("Session expired. Please login again.");
        setAuthenticationChecked && setAuthenticationChecked("UNAUTHORIZED");
      } else if (res.status === 403) {
        alert("Access denied - You don't have the required permissions.");
        setAuthenticationChecked && setAuthenticationChecked("FORBIDDEN");
      } else {
        throw new Error(`Error ${res.status}: ${res.statusText}`);
      }
      return;
    }

    const data = await res.json();
    if (data.success === true) {
      alert("Operator Account has been Updated");
    } else if (data.error) {
      if (
        data.error.code === "UNAUTHORIZED" ||
        data.error.includes("Authentication required")
      ) {
        alert("Session expired. Please login again.");
        setAuthenticationChecked && setAuthenticationChecked("UNAUTHORIZED");
      } else if (
        data.error.code === "FORBIDDEN" ||
        data.error.includes("Access denied")
      ) {
        alert("Access denied - You don't have the required permissions.");
        setAuthenticationChecked && setAuthenticationChecked("FORBIDDEN");
      } else {
        alert(`Error: ${data.error}`);
      }
    }
  } catch (err) {
    if (err.message.indexOf("401") > -1) {
      alert("Session expired. Please login again.");
      setAuthenticationChecked && setAuthenticationChecked("UNAUTHORIZED");
    } else if (err.message.indexOf("403") > -1) {
      alert("Access denied - You don't have the required permissions.");
      setAuthenticationChecked && setAuthenticationChecked("FORBIDDEN");
    } else {
      alert(`Failed to update account: ${err.message}`);
    }
  }
};

export const deleteOperatorAccountInfo = async (
  OperatorAccountInfo,
  setAuthenticationChecked,
) => {
  const endpoint = "/admin/account.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "DELETE",
    });

    if (!res.ok) {
      if (res.status === 401) {
        alert("Session expired. Please login again.");
        setAuthenticationChecked && setAuthenticationChecked("UNAUTHORIZED");
      } else if (res.status === 403) {
        alert("Access denied - You don't have the required permissions.");
        setAuthenticationChecked && setAuthenticationChecked("FORBIDDEN");
      } else {
        throw new Error(`Error ${res.status}: ${res.statusText}`);
      }
      return;
    }

    const data = await res.json();
    if (data.success === true) {
      alert("Operator Account has been Deleted");
    } else if (data.error) {
      if (
        data.error.code === "UNAUTHORIZED" ||
        data.error.includes("Authentication required")
      ) {
        alert("Session expired. Please login again.");
        setAuthenticationChecked && setAuthenticationChecked("UNAUTHORIZED");
      } else if (
        data.error.code === "FORBIDDEN" ||
        data.error.includes("Access denied")
      ) {
        alert("Access denied - You don't have the required permissions.");
        setAuthenticationChecked && setAuthenticationChecked("FORBIDDEN");
      } else {
        alert(`Error: ${data.error}`);
      }
    }
  } catch (err) {
    if (err.message.indexOf("401") > -1) {
      alert("Session expired. Please login again.");
      setAuthenticationChecked && setAuthenticationChecked("UNAUTHORIZED");
    } else if (err.message.indexOf("403") > -1) {
      alert("Access denied - You don't have the required permissions.");
      setAuthenticationChecked && setAuthenticationChecked("FORBIDDEN");
    } else {
      alert(`Failed to delete account: ${err.message}`);
    }
  }
};

export const getAgencies = async (setAgencies, setAuthenticationChecked) => {
  const endpoint = "/admin/agencies.json";
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });

    if (!res.ok) {
      if (res.status === 401) {
        setAuthenticationChecked && setAuthenticationChecked("UNAUTHORIZED");
      } else if (res.status === 403) {
        setAuthenticationChecked && setAuthenticationChecked("FORBIDDEN");
      }
      return;
    }

    const data = await res.json();
    if (data.success === true) {
      setAgencies(data.data);
    } else if (data.error) {
      if (data.error.code === "UNAUTHORIZED") {
        setAuthenticationChecked && setAuthenticationChecked("UNAUTHORIZED");
      } else if (data.error.code === "FORBIDDEN") {
        setAuthenticationChecked && setAuthenticationChecked("FORBIDDEN");
      }
    }
  } catch (err) {
    if (err.message.indexOf("401") > -1) {
      setAuthenticationChecked && setAuthenticationChecked("UNAUTHORIZED");
    } else if (err.message.indexOf("403") > -1) {
      setAuthenticationChecked && setAuthenticationChecked("FORBIDDEN");
    }
  }
};

export const checkLoginAvailability = async (login) => {
  const params = new URLSearchParams({
    login,
    excludeCurrentUser: "true",
  });
  const endpoint = `/admin/check-login.json?${params}`;
  try {
    const res = await fetch(process.env.REACT_APP_API_HOST + endpoint, {
      method: "GET",
    });
    res.json().then((res) => {
      login(res.data);
    });
    if (!res.ok) {
      throw new Error(`Error ${res.status} : ${res.statusText}`);
    }
  } catch (err) {}
};
